import { render } from "./UploadFileView.vue?vue&type=template&id=f6689a5a&scoped=true"
import script from "./UploadFileView.vue?vue&type=script&lang=js"
export * from "./UploadFileView.vue?vue&type=script&lang=js"

import "./UploadFileView.vue?vue&type=style&index=0&id=f6689a5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6689a5a"]])

export default __exports__